var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sort_svg__clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00001 10C3.00001 10.5523 3.44772 11 4.00001 11 4.55229 11 5.00001 10.5523 5.00001 10L5.00001 4.41421 6.29291 5.70711C6.68343 6.09763 7.3166 6.09763 7.70713 5.70711 8.09765 5.31658 8.09765 4.68342 7.70713 4.29289L4.70712 1.29289C4.51958 1.10536 4.26523 1 4.00001 1 3.73479 1 3.48044 1.10536 3.2929 1.29289L.292894 4.29289C-.0976313 4.68342-.0976314 5.31658.292894 5.70711.683419 6.09763 1.31659 6.09763 1.70711 5.70711L3.00001 4.41421 3.00001 10zM13 6C13 5.44772 12.5523 5 12 5 11.4477 5 11 5.44772 11 6L11 11.5858 9.70713 10.2929C9.3166 9.90237 8.68344 9.90237 8.29291 10.2929 7.90239 10.6834 7.90239 11.3166 8.29291 11.7071L11.2929 14.7071C11.4805 14.8946 11.7348 15 12 15 12.2652 15 12.5196 14.8946 12.7071 14.7071L15.7071 11.7071C16.0977 11.3166 16.0977 10.6834 15.7071 10.2929 15.3166 9.90237 14.6835 9.90237 14.2929 10.2929L13 11.5858 13 6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sort_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  })))));
}

export default SvgSort;